import { render, staticRenderFns } from "./post-single.vue?vue&type=template&id=20f5f617&scoped=true&"
import script from "./post-single.ts?vue&type=script&lang=ts&"
export * from "./post-single.ts?vue&type=script&lang=ts&"
import style0 from "./post-single.scss?vue&type=style&index=0&id=20f5f617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f5f617",
  null
  
)

export default component.exports